"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
class AlertInstance {
    /* eslint-enable @typescript-eslint/lines-between-class-members */
    constructor({ closable, content, heading, icon, role, slim, timeout, type }) {
        this.closable = closable !== undefined ? closable : false;
        this.content = content;
        this.fadeOut = false;
        this.heading = heading;
        this.icon = icon !== undefined ? icon : true;
        this.role = role;
        this.slim = slim !== undefined ? slim : false;
        this.timeout = timeout;
        this.type = type;
        this.uuid = (0, uuid_1.v4)();
    }
}
exports.default = AlertInstance;
